import {useHistory} from "react-router-dom";
import './Menu.css'
import toggleMenu from "./toggleMenu";


const Menu = ({updateToggle, isMobile}) => {
    const Options = {
        Home: "Home",
        Team: "Team",
        Training: "Training",
        News: "News",
        Contact: "Contact"
    }

    const history = useHistory()
    const loadPage = (e) => {
        switch (e.target.textContent.trim()){
            case Options.Home:
                history.push("/")
                toggleMenu('home')
                break;
            case Options.Team:
                history.push("/team")
                toggleMenu('team')
                break;
            case Options.Training:
                history.push("/training")
                toggleMenu('training')
                break;
            case Options.News:
                history.push("/news")
                toggleMenu('news')
                break;
            case Options.Contact:
                history.push("/contact")
                toggleMenu('contact')
                break;
            default:
                break;
        }
        //when moving back and forth from mobile to full view, the menu-bar should appear and disappear
        if (isMobile){
            updateToggle()
        }
    }
    return (
        <div className = 'menu-options'>
            <div className= 'home' onClick={loadPage}> Home
                <div className= 'underline-arrow'>
                    <div className= 'arrow1'/>
                    <div className= 'arrow2'/>
                    <div className= 'arrow3'/>
                    <div className= 'arrow4'/>
                </div>
            </div>
            <span className= 'hr-menu'> </span>
            <div className= 'team' onClick = {loadPage} > Team
                <div className= 'underline-arrow'>
                    <div className= 'arrow1'/>
                    <div className= 'arrow2'/>
                    <div className= 'arrow3'/>
                    <div className= 'arrow4'/>
                </div>
            </div>
            <span className= 'hr-menu'> </span>
            <div className= 'webinar-series' onClick = {loadPage} > Training
                <div className= 'underline-arrow'>
                    <div className= 'arrow1'/>
                    <div className= 'arrow2'/>
                    <div className= 'arrow3'/>
                    <div className= 'arrow4'/>
                </div>
            </div>
            <span className= 'hr-menu'> </span>
            <div className= 'news' onClick = {loadPage} > News
                <div className= 'underline-arrow'>
                    <div className= 'arrow1'/>
                    <div className= 'arrow2'/>
                    <div className= 'arrow3'/>
                    <div className= 'arrow4'/>
                </div>
            </div>
            <span className= 'hr-menu'> </span>
            <div className= 'contact' onClick = {loadPage}>Contact
                <div className= 'underline-arrow'>
                    <div className= 'arrow1'/>
                    <div className= 'arrow2'/>
                    <div className= 'arrow3'/>
                    <div className= 'arrow4'/>
                </div>
            </div>
        </div>
    )
}

export default Menu;

